import type { ProductCategoryType } from "../types";

export function getCategoryIdFromName(name: ProductCategoryType): number;
export function getCategoryIdFromName(name?: string): number;
export function getCategoryIdFromName(name?: string): number {
  switch (name) {
    case "api":
      return 1;
    case "software":
      return 2;
    case "connectivity":
      return 3;
    default:
      return 1;
  }
}

export function getCategoryNameFromId(id?: number | null): ProductCategoryType {
  switch (id) {
    case 1:
      return "api";
    case 2:
      return "software";
    case 3:
      return "connectivity";
    default:
      return "software";
  }
}

// Minimal shapes to avoid importing form schemas here
export type VariantFormBase = {
  quantity: number;
  price: number;
  unit: string;
  provisioningId?: string;
};

export type VariantFormWithId = VariantFormBase & {
  variantId?: number | null;
};

export type PackageFormBase = {
  name: string;
  isFreeTrial?: boolean;
  specifications: string[];
  variants: VariantFormBase[];
};

export type PackageFormWithId = Omit<PackageFormBase, "variants"> & {
  packageId?: number | null;
  variants: VariantFormWithId[];
};

export const mapVariantForCreate = (v: VariantFormBase) => ({
  quantity: v.quantity,
  price: v.price,
  unit: v.unit,
  provisioning_id: v.provisioningId || undefined
});

export const mapVariantForEdit = (v: VariantFormWithId) => ({
  id: v.variantId ?? undefined,
  quantity: v.quantity,
  price: v.price,
  unit: v.unit,
  provisioning_id: v.provisioningId || undefined
});

export const mapPackageForCreate = (p: PackageFormBase) => ({
  name: p.name,
  is_free_trial: p.isFreeTrial,
  specifications: p.specifications,
  variants: p.variants.map(mapVariantForCreate)
});

export const mapPackageForEdit = (p: PackageFormWithId) => ({
  id: p.packageId ?? undefined,
  name: p.name,
  is_free_trial: p.isFreeTrial,
  specifications: p.specifications,
  variants: p.variants.map(mapVariantForEdit)
});

export const buildPhotoForCreate = (mediaPath: string) => [
  { media_path: mediaPath, type: "image" as const }
];

export const buildPhotoForEdit = (
  mediaPath: string,
  productPhotoId?: number | null
) => [
  {
    id: productPhotoId ?? undefined,
    media_path: mediaPath,
    type: "image" as const
  }
];
